import { COMING_FROM_CASE, REFERRAL_ACCOUNT_BALANCE, CLEAR_REFERRAL_INFO, COMING_FROM_REFERRAL, 
    REFERRAL_ADDITIONAL_DETAILS, REFERRAL_FOR, REFERRAL_INCLUSION_TEAM, REFERRAL_OTHER_DETAILS, 
    REFERRAl_REASON, REASON_RESPONSE, IS_CASE_JOURNEY, IS_REPAIR_JOURNEY, SELECTED_SLOT, 
    IS_TRIAGE_REPAIR, DMC_DATA, DMC_ANS_DATA, REMOVE_DMC_DATA, STORE_SORDAMP, IS_CONTINUE_BUTTON_DISABLED, 
    CALENDER_INDEX, CALENDER_VALUE_OF_TRACK, DMC_CALENDER_INDEX, DMC_CALENDER_VALUE_OF_TRACK, SAVE_CUSTOMER_RENT_DETAILS, 
    SAVE_CUSTOMER_UC_FLAG,
    SAVE_DD_INSTRUCTION_ID,
    SAVE_DD_ACTUAL_FREQUENCY} from "../actionTypes";

export const financialReferralFor = (financialReferral: string): any => {
    return { type: REFERRAL_FOR, payload: financialReferral };
};

export const FinancialReferralReasonRes = (referralReason: any[]): any => {
    return { type: REFERRAl_REASON, payload: referralReason }
}

export const FinancialInclusionTeam = (inclusionTeam: boolean): any => {
    return { type: REFERRAL_INCLUSION_TEAM, payload: inclusionTeam }
}


export const FinancialOtherDetails = (otherDetails: string): any => {
    return { type: REFERRAL_OTHER_DETAILS, payload: otherDetails }
}

export const clearReferralInformation = (data: any): any => {
    return { type: CLEAR_REFERRAL_INFO, payload: data }
}

export const comingFromReferralPage = (data: boolean): any => {
    return { type: COMING_FROM_REFERRAL, payload: data }
}

export const storeReferralAdditionalDetails = (data: any): any => {
    return { type: REFERRAL_ADDITIONAL_DETAILS, payload: data }
}

export const saveReferralAccountBalance = (data: string): any => {
    return { type: REFERRAL_ACCOUNT_BALANCE, payload: data }
}

export const saveReasonResponse = (data: any): any => {
    return { type: REASON_RESPONSE, payload: data }
}

export const comingFromCasePage = (data: boolean): any => {
    return { type: COMING_FROM_CASE, payload: data }
}

export const comingFromCaseJourneySuccess = (data: boolean): any => {
    return { type: IS_CASE_JOURNEY, payload: data }
}

export const comingFromRepairJourneySuccess = (data: boolean): any => {
    return { type: IS_REPAIR_JOURNEY, payload: data }
}

export const setTriageRepair = (data: boolean): any => {
    return { type: IS_TRIAGE_REPAIR, payload: data }
}

export const saveSelectedSlotDate = (payload: any): any => {
    return { type: SELECTED_SLOT, payload }
}
export const saveDMCQuestions = (data: any): any => {
    return { type: DMC_DATA, payload: data }
}

export const saveDMCAnswers = (data: any): any => {
    return { type: DMC_ANS_DATA, payload: data }
}

export const RemoveAllDMCData = (data: any): any => {
    return { type: REMOVE_DMC_DATA, payload: data }
}
export const storeSORDAMP = (data: any): any => {
    return { type: STORE_SORDAMP, payload: data }
}

export const isContinueButtonDisabled = (data: boolean): any => {
    return { type: IS_CONTINUE_BUTTON_DISABLED, payload: data }
}
export const savingCalenderIndex = (data: any): any => {
    return { type: CALENDER_INDEX, payload: data }
}

export const savingcalenderTrackValue = (data: string): any => {
    return { type: CALENDER_VALUE_OF_TRACK, payload: data }
}
export const savingDmcCalenderIndex = (data: any): any => {
    return { type: DMC_CALENDER_INDEX, payload: data }
}

export const savingDmcCalenderTrackValue = (data: string): any => {
    return { type: DMC_CALENDER_VALUE_OF_TRACK, payload: data }
}

export const saveCustomerRentDetails = (data:any):any => {
    return {type:SAVE_CUSTOMER_RENT_DETAILS, payload:data}
}
export const saveCustomerUCFlag = (data:boolean):any => {
    return {type:SAVE_CUSTOMER_UC_FLAG, payload:data}
}

export const saveDirectDebitRefeneceId = (data:string):any => {
    return {type:SAVE_DD_INSTRUCTION_ID, payload:data}
}

export const saveActualFrequencyFromDropDown = (data:string):any => {
    return {type:SAVE_DD_ACTUAL_FREQUENCY, payload:data}
}